module.exports = __webpack_public_path__ + "static/assets/af0caec5f8ac3a35c9769e1e07918e14.mp3";